module.exports = require("fast-glob");;